(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("riskElementService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 269,
                    parameters: parms || {}
                });
            },
            listRisks: function (parms) {
                return $ihttp.post({
                    method: 272,
                    parameters: parms || {}
                });
            },
            listLogs: function (parms) {
                return $ihttp.post({
                    method: 307,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 273,
                    parameters: edit
                });
            },
            confirmItem: function (edit) {
                return $ihttp.post({
                    method: 306,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 274,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
